/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './countries';
import './geocode';
import './script';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "address": {
            "nested": {
              "Address": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "country": {
                    "type": "squareup.common.countries.Country",
                    "id": 2,
                    "rule": "optional"
                  },
                  "main": {
                    "type": "squareup.common.address.AddressEntry",
                    "id": 3,
                    "rule": "optional"
                  },
                  "alt": {
                    "type": "squareup.common.address.AddressEntry",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "verification": {
                    "type": "squareup.common.address.Verification",
                    "id": 5,
                    "rule": "optional"
                  },
                  "geocode": {
                    "type": "squareup.common.geocode.Geocode",
                    "id": 7,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": "squareup.common.address.AddressMetadata",
                    "id": 8,
                    "rule": "optional"
                  },
                  "instructions": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "piiStatus": {
                    "type": "squareup.common.address.Address.PiiStatus",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PiiStatus": {
                    "values": {
                      "UNKNOWN_PII_STATUS": 0,
                      "MIXED": 1,
                      "KNOWN_PII": 2,
                      "KNOWN_NOT_PII": 3
                    }
                  }
                }
              },
              "AddressEntry": {
                "fields": {
                  "script": {
                    "type": "squareup.common.script.Script",
                    "id": 1,
                    "rule": "optional"
                  },
                  "address": {
                    "type": "squareup.common.address.AddressDetails",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "AddressDetails": {
                "fields": {
                  "recipient": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "organization": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lines": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "locality": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sublocality": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sublocality1": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "sublocality2": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "sublocality3": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "sublocality4": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "sublocality5": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "adminLevel1": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "adminLevel2": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "adminLevel3": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "adminLevel4": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "adminLevel5": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "postalCode": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "sortingCode": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  }
                }
              },
              "AddressMetadata": {
                "fields": {
                  "residential": {
                    "type": "squareup.common.address.AddressMetadata.Residential",
                    "id": 1,
                    "rule": "optional"
                  },
                  "addressType": {
                    "type": "squareup.common.address.AddressMetadata.AddressType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "agrexCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "prefectureIsoCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Residential": {
                    "values": {
                      "UNKNOWN_RESIDENTIAL_STATUS": 0,
                      "RESIDENTIAL": 1,
                      "COMMERCIAL": 2
                    }
                  },
                  "AddressType": {
                    "values": {
                      "UNKNOWN_ADDRESS_TYPE": 0,
                      "FIRM": 1,
                      "GENERAL_DELIVERY": 2,
                      "HIGH_RISE_OR_COMPLEX": 3,
                      "PO_BOX": 4,
                      "RURAL_ROUTE": 5,
                      "STREET": 6,
                      "MIXED": 7,
                      "SMALL": 8,
                      "LARGE": 9
                    }
                  }
                }
              },
              "Verification": {
                "fields": {
                  "verificationStatus": {
                    "type": "squareup.common.address.Verification.VerificationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "verificationLevel": {
                    "type": "squareup.common.address.Verification.VerificationLevel",
                    "id": 2,
                    "rule": "optional"
                  },
                  "verifiedAt": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "debugInfo": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "VerificationStatus": {
                    "values": {
                      "UNVERIFIED": 0,
                      "VERIFY_FAILED": 1,
                      "PARTIALLY_VERIFIED": 2,
                      "VERIFIED": 3
                    }
                  },
                  "VerificationLevel": {
                    "values": {
                      "UNKNOWN_VERIFICATION_LEVEL": 0,
                      "ADMINISTRATIVE_AREA": 1,
                      "LOCALITY": 2,
                      "THOROUGHFARE": 3,
                      "PREMISES": 4,
                      "SUBPREMISES": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.address?.nested?.Address && !$root.nested?.squareup?.nested?.common?.nested?.address?.nested?.Address?.nested?.PiiStatus && !$root.nested?.squareup?.nested?.common?.nested?.address?.nested?.AddressEntry && !$root.nested?.squareup?.nested?.common?.nested?.address?.nested?.AddressDetails && !$root.nested?.squareup?.nested?.common?.nested?.address?.nested?.AddressMetadata && !$root.nested?.squareup?.nested?.common?.nested?.address?.nested?.AddressMetadata?.nested?.Residential && !$root.nested?.squareup?.nested?.common?.nested?.address?.nested?.AddressMetadata?.nested?.AddressType && !$root.nested?.squareup?.nested?.common?.nested?.address?.nested?.Verification && !$root.nested?.squareup?.nested?.common?.nested?.address?.nested?.Verification?.nested?.VerificationStatus && !$root.nested?.squareup?.nested?.common?.nested?.address?.nested?.Verification?.nested?.VerificationLevel) {
  $root.addJSON(jsonData);
}

/**
 * An address represented in multiple scripts.
 *
 * Do not use this protobuf in new code. Use GlobalAddress, which matches the public API
 * at Square as well as general norms for address management at other web sites.
 *
 * SOURCE Address @ squareup/common/address.proto at 17:1
 */
export const Address = $root.lookupType('squareup.common.address.Address');
fixType(Address);
Builder.createAndAttachToType(Address);
/**
 * SOURCE PiiStatus @ squareup/common/address.proto at 53:3
 */
Address.PiiStatus = $root.lookupEnum('squareup.common.address.Address.PiiStatus').values;
/**
 * One representation of an address in a single script
 *
 * SOURCE AddressEntry @ squareup/common/address.proto at 68:1
 */
export const AddressEntry = $root.lookupType('squareup.common.address.AddressEntry');
fixType(AddressEntry);
Builder.createAndAttachToType(AddressEntry);
/**
 * A single representation of an address.
 *
 * Note that not all fields are used or populated by various services - see individual service
 * APIs for details on what is used/populated and under what conditions.
 *
 * Also note that generally these fields refer to an address as used for mail delivery, and may
 * not correspond with boundaries for things like tax jurisdiction.  For example, in the US the
 * city (and even the state) refer to where the post office is that delivers to a given location,
 * and may not be the same as the actual entity that contains the address.  For such uses to be
 * completely accurate, take the geocode and lookup the containing city limits, state boundary, etc.
 *
 * See also https://developers.google.com/maps/documentation/geocoding/intro
 *
 * SOURCE AddressDetails @ squareup/common/address.proto at 88:1
 */
export const AddressDetails = $root.lookupType('squareup.common.address.AddressDetails');
fixType(AddressDetails);
Builder.createAndAttachToType(AddressDetails);
/**
 * SOURCE AddressMetadata @ squareup/common/address.proto at 133:1
 */
export const AddressMetadata = $root.lookupType('squareup.common.address.AddressMetadata');
fixType(AddressMetadata);
Builder.createAndAttachToType(AddressMetadata);
/**
 * TODO(jat): include additional metadata, such as school/voting districts
 *
 * SOURCE Residential @ squareup/common/address.proto at 149:3
 */
AddressMetadata.Residential = $root.lookupEnum('squareup.common.address.AddressMetadata.Residential').values;
/**
 * SOURCE AddressType @ squareup/common/address.proto at 159:3
 */
AddressMetadata.AddressType = $root.lookupEnum('squareup.common.address.AddressMetadata.AddressType').values;
/**
 * SOURCE Verification @ squareup/common/address.proto at 182:1
 */
export const Verification = $root.lookupType('squareup.common.address.Verification');
fixType(Verification);
Builder.createAndAttachToType(Verification);
/**
 * TODO(jat): some way to represent which parts of a multi-script address had issues
 *
 * SOURCE VerificationStatus @ squareup/common/address.proto at 198:3
 */
Verification.VerificationStatus = $root.lookupEnum('squareup.common.address.Verification.VerificationStatus').values;
/**
 * SOURCE VerificationLevel @ squareup/common/address.proto at 212:3
 */
Verification.VerificationLevel = $root.lookupEnum('squareup.common.address.Verification.VerificationLevel').values;